// src/pages/admin/DeliveryPartnerLogin.jsx
import React, { useState } from "react";
import { auth, db } from "../../firebase/config";
import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { doc, getDoc } from "firebase/firestore";
import { useNavigate } from "react-router-dom";

const DeliveryPartnerLogin = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ Check user status and redirect accordingly
  const checkUserStatusAndRedirect = async (user) => {
    try {
      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);
      
      if (userSnap.exists()) {
        const userData = userSnap.data();
        if (userData.status === "approved") {
          // Approved partner - go to dashboard
          navigate("/partner/dashboard");
          return;
        } else if (userData.status === "rejected") {
          // Rejected partner - go to rejected page
          navigate("/delivery-partner/rejected");
          return;
        }
      }
      // New user or pending - go to registration
      navigate("/delivery-partner/register");
    } catch (error) {
      console.error("Error checking user status:", error);
      // Fallback to registration
      navigate("/delivery-partner/register");
    }
  };

  const handleGoogleLogin = async () => {
    setLoading(true);
    try {
      const provider = new GoogleAuthProvider();
      const result = await signInWithPopup(auth, provider);
      alert("✅ Logged in with Google.");
      await checkUserStatusAndRedirect(result.user);
    } catch (err) {
      console.error("Google Login Failed:", err);
      alert("❌ Google login failed. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-green-50">
      <div className="bg-white p-8 rounded-xl shadow-md w-full max-w-md">
        <div className="text-4xl mb-2 text-center">🚚</div>
        <h2 className="text-2xl font-bold mb-6 text-center text-green-700">
          Delivery Partner Login
        </h2>
        <button
          onClick={handleGoogleLogin}
          disabled={loading}
          className="w-full bg-blue-600 text-white py-3 rounded-lg hover:bg-blue-700 mb-4 flex items-center justify-center gap-2"
        >
          <svg width="20" height="20" viewBox="0 0 48 48"><g><path fill="#4285F4" d="M43.611 20.083H42V20H24v8h11.303C34.89 32.062 29.865 35 24 35c-6.627 0-12-5.373-12-12s5.373-12 12-12c2.69 0 5.164.896 7.163 2.385l6.084-6.084C33.527 5.053 28.977 3 24 3c-7.732 0-14.313 4.41-17.694 10.691z"/><path fill="#34A853" d="M6.306 14.691l6.571 4.819C14.655 16.108 19.01 13 24 13c2.69 0 5.164.896 7.163 2.385l6.084-6.084C33.527 5.053 28.977 3 24 3c-7.732 0-14.313 4.41-17.694 10.691z"/><path fill="#FBBC05" d="M24 43c5.798 0 10.668-1.924 14.224-5.217l-6.577-5.406C29.865 35 26.13 37 24 37c-5.837 0-10.77-3.938-12.53-9.293l-6.54 5.037C7.97 39.045 15.954 43 24 43z"/><path fill="#EA4335" d="M43.611 20.083H42V20H24v8h11.303c-1.13 3.062-4.435 7-11.303 7-6.627 0-12-5.373-12-12s5.373-12 12-12c2.69 0 5.164.896 7.163 2.385l6.084-6.084C33.527 5.053 28.977 3 24 3c-7.732 0-14.313 4.41-17.694 10.691z" opacity=".3"/></g></svg>
          {loading ? "Signing in..." : "Sign in with Google"}
        </button>
      </div>
    </div>
  );
};

export default DeliveryPartnerLogin;
